export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7645.ad803ef1.jpg";